import React from 'react';
import { useDispatch } from 'react-redux';
import { updateUserContacts } from '.';

export default function useUpdateUserContacts() {
  const dispatch = useDispatch();
  return React.useCallback(payload => dispatch(updateUserContacts(payload)), [dispatch]);
}